export const triggerHeatMap = name => {
  window.hj =
    window.hj ||
    function() {
      (hj.q = hj.q || []).push(arguments);
    };
  hj('trigger', name);
};
